/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_15_SInputs */

const en_funnel_ob_daily_15_s = /** @type {(inputs: Funnel_Ob_Daily_15_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One article or a few pages`)
};

const es_funnel_ob_daily_15_s = /** @type {(inputs: Funnel_Ob_Daily_15_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un artículo o unas cuantas páginas`)
};

/**
* | output |
* | --- |
* | "One article or a few pages" |
*
* @param {Funnel_Ob_Daily_15_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_15_s = /** @type {((inputs?: Funnel_Ob_Daily_15_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_15_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_15_s(inputs)
	return en_funnel_ob_daily_15_s(inputs)
});